import { useDispatch, useSelector } from "react-redux";
import { setDialogChanged } from "../actions/dialog";
import { IReduxAppState } from "../reducers";



export function useChangedDialog() {
    const dispatch = useDispatch();
    const hasChanged = useSelector((state: IReduxAppState) => state.dialog.hasChanged);
    const multiDialogHasChanged = useSelector((state: IReduxAppState) => state.dialog.multiDialogHasChanged);

    
    
    function hasFormChanged(isDirty: boolean) {
        if(multiDialogHasChanged){
            dispatch(setDialogChanged(multiDialogHasChanged));
        }else if(hasChanged !== isDirty) {
            dispatch(setDialogChanged(isDirty));
        }
    }
    return { hasFormChanged }
}